module.exports = __webpack_public_path__ + "img/45600.923ea9be.jpg";